module.exports = __webpack_public_path__ + "static/media/wenti1.cddd4c5d.png";